(function () {
  function campaignContext(element) {
    var params = new URLSearchParams(window.location.search);
    var context = {
      campaign_id: element.dataset.homepageHeroPromotionId,
      page_path: window.location.pathname,
    };

    ["ref", "utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"].forEach(
      function (key) {
        var value = params.get(key);
        if (value) context[key] = value;
      }
    );

    return context;
  }

  function track(element, eventName, details) {
    var payload = Object.assign({}, campaignContext(element), details || {});
    var envelope = Object.assign({ event: eventName }, payload);

    window.__homepageHeroAnalyticsQueue = window.__homepageHeroAnalyticsQueue || [];
    window.__homepageHeroAnalyticsQueue.push(envelope);
    document.dispatchEvent(new CustomEvent("gl:homepage_hero", { detail: envelope }));

    if (typeof window.gtag === "function") {
      window.gtag("event", eventName, payload);
      return;
    }

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(envelope);
    }
  }

  function promotionRoots(root) {
    var roots = [];

    if (
      root.matches &&
      root.matches('[data-homepage-hero-promotion][data-homepage-hero-analytics-mode="generic"]')
    ) {
      roots.push(root);
    }

    return roots.concat(
      Array.prototype.slice.call(
        root.querySelectorAll(
          '[data-homepage-hero-promotion][data-homepage-hero-analytics-mode="generic"]'
        )
      )
    );
  }

  function initPromotionViews(root) {
    promotionRoots(root).forEach(function (element) {
      if (element.dataset.homepageHeroViewed === "true") return;
      element.dataset.homepageHeroViewed = "true";

      track(element, "view_promotion", {
        promotion_id: element.dataset.homepageHeroPromotionId,
        promotion_name: element.dataset.homepageHeroPromotionName,
        creative_slot: element.dataset.homepageHeroPlacement || "homepage_hero",
      });
    });
  }

  function init(root) {
    initPromotionViews(root);

    if (document.documentElement.dataset.homepageHeroTrackingReady === "true") return;
    document.documentElement.dataset.homepageHeroTrackingReady = "true";

    document.addEventListener("click", function (event) {
      var target = event.target.closest('[data-homepage-hero-track="select_promotion"]');
      if (!target) return;

      var promotion = target.closest(
        '[data-homepage-hero-promotion][data-homepage-hero-analytics-mode="generic"]'
      );
      if (!promotion) return;

      track(promotion, "select_promotion", {
        promotion_id: promotion.dataset.homepageHeroPromotionId,
        promotion_name: promotion.dataset.homepageHeroPromotionName,
        creative_slot: promotion.dataset.homepageHeroPlacement || "homepage_hero",
        location: target.dataset.homepageHeroLocation || "homepage_hero",
        destination: target.getAttribute("href") || undefined,
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
